function hexToRgb(hex) {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
  }
  
  // Функция за изчисляване на относителната яркост на цвят
  function luminance(r, g, b) {
    const a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }
  
  // Функция за изчисляване на контраста между два цвята
  function contrast(rgb1, rgb2) {
    const lum1 = luminance(rgb1[0], rgb1[1], rgb1[2]) + 0.05;
    const lum2 = luminance(rgb2[0], rgb2[1], rgb2[2]) + 0.05;
    return lum1 > lum2 ? lum1 / lum2 : lum2 / lum1;
  }
  
  // Функция за проверка на контраста между два HEX цвята
  export const checkContrast = (textColorHex, bgColorHex) => {
    const textColorRgb = hexToRgb(textColorHex);
    const bgColorRgb = hexToRgb(bgColorHex);
    const contrastRatio = contrast(textColorRgb, bgColorRgb);
    return contrastRatio >= 4.5;  // Връща true, ако контрастът е достатъчен
  }